module.exports = __webpack_public_path__ + "assets/img/banner3.a375961d.png";